export default {
  id: "ID",
  date: "Data",
  amount: "Valor do empréstimo",
  installments: "Número de parcelas",
  status: "Status",
  approved: "Aprovada",
  applied: "Solicitação iniciada",
  issued: "Aprovada",
  in_progress: "Aguardando aprovação",
  withdrawn: "Cancelada",
  declined: "Rejeitada",
  ebs_declined: "Rejeitada",
  paid_off: "Quitado",
  contract_unsigned: "Contrato não assinado",
  underwriting_approved: "Pré Aprovado"
}
